import { Badge } from "@rosc/ui/components/badge";
import { Button } from "@rosc/ui/components/button";
import { useEffect, useState } from "react";

export function AdminStepUpBanner({
  deadline,
  onConfirm,
  onLock,
}: {
  deadline: number;
  onConfirm: () => void;
  onLock: () => void;
}) {
  const [now, setNow] = useState(Date.now);
  const seconds = Math.max(0, Math.ceil((deadline - now) / 1000));
  // biome-ignore lint/correctness/useExhaustiveDependencies: Restart the tick when the server supplies a new deadline.
  useEffect(() => {
    const tick = () => setNow(Date.now());
    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [deadline]);
  useEffect(() => {
    if (seconds === 0) onConfirm();
  }, [seconds, onConfirm]);
  return (
    <section
      className="flex flex-wrap items-center gap-3 border-b p-4"
      aria-label="Admin access"
    >
      <span>Admin access expires in</span>
      <Badge variant="outline">
        {String(Math.floor(seconds / 60)).padStart(2, "0")}:
        {String(seconds % 60).padStart(2, "0")}
      </Badge>
      <Button variant="outline" onClick={onConfirm}>
        Confirm again
      </Button>
      <Button onClick={onLock}>Lock</Button>
    </section>
  );
}
